// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"187":"NotFound","397":"Blog","843":"ProjectYIP","877":"Projects","994":"ProjectDetails"}[chunkId] + "-legacy." + {"187":"623fc95e","397":"beed3f57","843":"5ee3818a","877":"08abb05c","994":"954f5a25"}[chunkId] + ".js";
};